module.exports = __webpack_public_path__ + "static/media/logo_vietabank.ee9bbf73.svg";